import React, { useState, useRef, FocusEvent } from "react";
import { Card, Form, Button } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { CreateAccountUIActionTypes, GlobalConstants, LoginWebUIActionTypes } from "src/common";
import { CountdownDisplay, VerificationCode } from "src/components";
import verifiedImage from "src/assets/images/verified.svg";

type AllProps = {
  user_id: string;
  expires: string;
  handleAction: ActionHandlerFunction;
}

function EmailCodeVerificationFormComponent(props: AllProps) {
  const { user_id, expires, handleAction } = props;
  const [expired, setExpired] = useState<boolean>(false);
  const form_ref = useRef<HTMLFormElement>(null);
  const button_ref = useRef<HTMLButtonElement>(null);
  let secret = "";


  // Description: Validate and set secret code on finished
  function handleSetSecretCode(code: string) {
    secret = code;
    const button = button_ref.current;
    const is_valid = code.length === GlobalConstants.CREATE_ACCOUNT_VERIFICATION_CODE_MAX;

    if (!!button) {
      button.disabled = !is_valid;
      is_valid && setTimeout(() => button.focus());
    }
    is_valid && handleSubmit();
  }

  // Description: Handle form submit
  async function handleSubmit() {
    handleAction({
      actionType: CreateAccountUIActionTypes.SubmitVerificationCode, params: ({ secret, user_id })
    });
    (!!form_ref.current) && form_ref.current.reset();
  }

  // Description: Expiration Message Panel
  function VerificationCodeExpired() {
    return <>
      <p>
        The verification code that was sent to <b>{user_id}</b> has expired. Please click <b>Back</b> to restart the process.
      </p>
      <div className="btn-panel">
        <Button variant="outline-secondary" type="button"
          onClick={() => handleAction({ actionType: LoginWebUIActionTypes.ResetLogin })}>Back</Button>
      </div>
    </>;
  }

  // Description: Render the enter code
  function VerificationForm() {
    return <>
      <h2 className="border-bottom">Check your inbox!</h2>
      <p>We sent <b>{user_id}</b> an email with the verification code.
        This code expires in <b><CountdownDisplay expires={expires} handleTimeExpired={() => setExpired(true)} /></b>.</p>
      <Form onSubmit={(e: FocusEvent<HTMLFormElement, Element>) => {
        e.stopPropagation();
        e.preventDefault();
        handleSubmit();
      }} ref={form_ref} noValidate >
        <Form.Group className="mb-4 col-sm-10">
          <Form.Label className="fs-6">Verification Code</Form.Label>
          <VerificationCode count={GlobalConstants.CREATE_ACCOUNT_VERIFICATION_CODE_MAX} handleAction={handleSetSecretCode} />
        </Form.Group>
        <div className="btn-panel">
          <Button ref={button_ref} type="submit" disabled={true} >Verify</Button>
          <Button variant="outline-secondary" type="button"
            onClick={() => handleAction({ actionType: LoginWebUIActionTypes.ResetLogin })}>Back</Button>
        </div>
      </Form>
    </>;
  }

  return <>
    <Card.Img variant="top" src={verifiedImage} />
    <Card.Body>
      {
        expired ? <VerificationCodeExpired /> : <VerificationForm />
      }
    </Card.Body>
  </>;
}

export default React.memo(EmailCodeVerificationFormComponent);
